<template>
  <div class="board ma-0">   
    <v-row>
      <ExperimentTitle />
    </v-row> 
    <div v-if="name == 'respiration'">
      <RespirationDashboard />
    </div>
    <div v-if="name == 'photosynthesis'">
      <PhotosynthesisDashboard />
    </div>
    <v-container>
    <v-row>
      <v-col xs="12" sm="3">
        <v-card>
          <v-img v-if="api.config.set_0.record == '1' & api.config.set_0.light == '1'"
              :src="api.config['set_0'].filename_on"
            >
            </v-img>
            <v-img v-else-if="api.config.set_0.record == '1' & api.config.set_0.light == '0'"
              :src="api.config['set_0'].filename_off"
            >
            </v-img>
          <v-card-text class="text-center">
            <table class="text-left">
                <tr v-for="item in api['set_0']" :key="item.key">
                  <td>{{ item.key }}:</td>
                  <td class='pl-3'>{{item.value}}</td>
                </tr>
            </table>
          </v-card-text>
          <v-card-actions class="justify-center pb-6">
            <v-btn
              rounded
              color="blue-grey lighten-1"
              dark
              class="p-4"
              @click="enterRoom('set_0')"
            >
              Enter Room 1
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col xs="12" sm="3">
        <v-card>
          <v-img v-if="api.config.set_1.record == '1' & api.config.set_1.light == '1'"
              :src="api.config['set_1'].filename_on"
            >
            </v-img>
            <v-img v-else-if="api.config.set_1.record == '1' & api.config.set_1.light == '0'"
              :src="api.config['set_1'].filename_off"
            >
            </v-img>
          <v-card-text class="text-center">
            <table class="text-left">
                <tr v-for="item in api['set_1']" :key="item.key">
                  <td>{{ item.key }}:</td>
                  <td class='pl-3'>{{item.value}}</td>
                </tr>
            </table>
          </v-card-text>
          <v-card-actions class="justify-center pb-6">
            <v-btn
              rounded
              color="blue-grey lighten-1"
              dark
              class="p-4"
              @click="enterRoom('set_1')"
            >
              Enter Room 2
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col xs="12" sm="3">
        <v-card>
          <v-img v-if="api.config.set_2.record == '1' & api.config.set_2.light == '1'"
              :src="api.config['set_2'].filename_on"
            >
            </v-img>
            <v-img v-else-if="api.config.set_2.record == '1' & api.config.set_2.light == '0'"
              :src="api.config['set_2'].filename_off"
            >
            </v-img>
          <v-card-text class="text-center">
            <table class="text-left">
                <tr v-for="item in api['set_2']" :key="item.key">
                  <td>{{ item.key }}:</td>
                  <td class='pl-3'>{{item.value}}</td>
                </tr>
            </table>
          </v-card-text>
          <v-card-actions class="justify-center pb-6">
            <v-btn
              rounded
              color="blue-grey lighten-1"
              dark
              class="p-4"
              @click="enterRoom('set_2')"
            >
              Enter Room 3
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col xs="12" sm="3">
        <v-card>
          <v-img v-if="api.config.set_3.record == '1' & api.config.set_3.light == '1'"
              :src="api.config['set_3'].filename_on"
            >
            </v-img>
            <v-img v-else-if="api.config.set_3.record == '1' & api.config.set_3.light == '0'"
              :src="api.config['set_3'].filename_off"
            >
            </v-img>
          <v-card-text class="text-center">
            <table class="text-left">
                <tr v-for="item in api['set_3']" :key="item.key">
                  <td>{{ item.key }}:</td>
                  <td class='pl-3'>{{item.value}}</td>
                </tr>
            </table>
          </v-card-text>
          <v-card-actions class="justify-center pb-6">
            <v-btn
              rounded
              color="blue-grey lighten-1"
              dark
              class="p-4"
              @click="enterRoom('set_3')"
            >
              Enter Room 4
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    </v-container>
  </div>
</template>
<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import RespirationDashboard from "@/components/RespirationDashboard.vue";
import PhotosynthesisDashboard from "@/components/PhotosynthesisDashboard.vue";
import { Admin_APIService } from "@/services/Admin_APIService";
import { Board_APIService } from "@/services/Board_APIService";
const apiService = new Admin_APIService(process.env.VUE_APP_BASE_URL);
const boardService = new Board_APIService(process.env.VUE_APP_BASE_URL);
export default {
  name: "dashboard",
  components: {
    ExperimentTitle,
    RespirationDashboard,
    PhotosynthesisDashboard,
  },
  data: function () {
    return {
      name: "",
      role: null,
      description: {
        
      },
      base_url:process.env.VUE_APP_BASE_URL,
      api: {
        set_0: "",
        set_1: "",
        set_2: "",
        set_3: "",
        lights: {
          set_0: '',
          set_1: '',
          set_2: '',
          set_3: '',
        },
        config: {
          set_0: '',
          set_1: '',
          set_2: '',
          set_3: '',
        },
      },
    };
  },
  mounted: function () {
    var self = this;
    self.$ga.page("/board/" + this.$route.params.experiment_name);
    self.name = this.$route.params.experiment_name.toUpperCase();
    var ga_counter = 0;
    self.getCondition('set_0');
    self.getCondition('set_1');
    self.getCondition('set_2');
    self.getCondition('set_3');
    self.getBoardExperimentLight(self.name, "set_0");
    self.getBoardExperimentLight(self.name, "set_1");
    self.getBoardExperimentLight(self.name, "set_2");
    self.getBoardExperimentLight(self.name, "set_3");
    self.getDashboardConfig(self.name, "set_0");
    self.getDashboardConfig(self.name, "set_1");
    self.getDashboardConfig(self.name, "set_2");
    self.getDashboardConfig(self.name, "set_3");
  },
  methods: {
    enterRoom(equipment_id){
      var self = this;
      self.$cookies.set('equipment_id', equipment_id);
      self.$router.push("/board/"+self.$route.params.experiment_name+"/"+equipment_id);
    },
    getCondition(equipment_id){
      var self = this;
      self.equipment_id = equipment_id;
      apiService
        .getCondition(this.name, equipment_id)
        .then((response) => {
          self.api[response.equipment_id] = JSON.parse(response.value);
        });
    },
    getBoardExperimentLight(experiment, equipment_id, callback) {
      var self = this;
      apiService
        .getBoardExperimentLight(experiment, equipment_id)
        .then((response) => {
          self.api.lights[equipment_id] = response.light_on;
//          console.log(response);
          if (callback) {
            callback();
          }
        });
    },
    getDashboardConfig(experiment, equipment_id, callback) {
      var self = this;
      boardService
        .getDashboardConfig(experiment, equipment_id)
        .then((response) => {
          //self.api.lights[equipment_id] = response.light_on;
          
          self.api.config[equipment_id] = response;
          self.api.config[equipment_id].filename_on = process.env.VUE_APP_BASE_URL+"/api/"+self.api.config[equipment_id].filename_on;
          self.api.config[equipment_id].filename_off = process.env.VUE_APP_BASE_URL+"/api/"+self.api.config[equipment_id].filename_off;
          console.log(self.api.config[equipment_id]);
          if (callback) {
            callback();
          }
        });
    },
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>